import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IAppointment, AppointmentType, AppointmentStatus, ExpeditionType } from "@/models";

@Component({
    name: "security-detail",
})

export default class SecurityDetail extends Vue {
    public title: string;

    public constructor() {
        super();

        if (this.appointment.type === AppointmentType.Expedition) {
            this.title = "EXPEDITION";
        } else {
            this.title = "RECEPTION";
        }
    }

    public get appointment(): IAppointment {
        return this.$store.getters["security/getSelectedAppointment"]();
    }

    public arrived(): void {

        const data: any = {
            appointmentId: this.appointment.appointmentId,
            status: 2,
        };

        if (this.appointment.type === AppointmentType.Reception) {
            data.type = AppointmentType.Reception;
        } else {
            data.type = AppointmentType.Expedition;
        }

        this.$store.dispatch("security/updateAppointmentState", data);

        this.goBackward();
    }

    public notArrived(): void {

        const data: any = {
            appointmentId: this.appointment.appointmentId,
            status: 1,
        };

        if (this.appointment.type === AppointmentType.Reception) {
            data.type = AppointmentType.Reception;
        } else {
            data.type = AppointmentType.Expedition;
        }

        this.$store.dispatch("security/updateAppointmentState", data);

        this.goBackward();
    }

    public getStatusString(status: AppointmentStatus): string {
        switch (status) {
            case AppointmentStatus.Waiting:
                return "En attente du camion";
            case AppointmentStatus.InProgress:
                return "En cours";
            case AppointmentStatus.Done:
                return "Terminé";
            case AppointmentStatus.Cancel:
                return "Annulé";
        }
    }

    public goBackward(): void {
        this.$router.back();
        this.$store.commit("security/SET_SELECTED_APPOINTMENT", null);
    }

    public displayLabelExpedition() {
        switch (this.appointment.expeditionType) {
            case ExpeditionType.Shuttle:
                return this.appointment.transporterName;
            case ExpeditionType.Container:
                return "DS";
            case ExpeditionType.Other:
                return this.appointment.comment;
            default:
                return "";
        }
    }

    public displayLabelReception(): string {
        return this.appointment.transporterName ? this.appointment.transporterName : "DS";
    }
}
